/* eslint-disable max-len */

import React from 'react';
import { Svg, Path, G } from '@react-pdf/renderer';

export const GoldIcon: React.FC = () => {
  return (
    <Svg width={42} height={42}>
      <G fill="none" fillRule="evenodd">
        <Path
          d="M21.693 8.561c7.186 0 13.012 5.826 13.012 13.012 0 7.185-5.826 13.011-13.012 13.011-7.186 0-13.012-5.826-13.012-13.01 0-7.187 5.826-13.013 13.012-13.013Zm.793 5.48c-2.253 0-4.015.622-5.286 1.864-1.27 1.243-1.906 2.974-1.906 5.196 0 2.284.548 4.036 1.643 5.257 1.095 1.22 2.68 1.83 4.758 1.83.816 0 1.614-.058 2.395-.174a15.391 15.391 0 0 0 2.5-.607v-7.135h-5.46v2.429h2.607v2.87a9.439 9.439 0 0 1-1.854.189c-1.167 0-2.056-.394-2.668-1.181-.612-.788-.918-1.928-.918-3.422 0-1.43.38-2.57 1.139-3.417.76-.847 1.77-1.27 3.03-1.27 1.086 0 2.131.25 3.135.753l.97-2.334a10.226 10.226 0 0 0-4.085-.848Z"
          fill="#D3AD36"
        />
        <Path
          d="M21.5 5.263c4.45 0 8.478 1.804 11.394 4.72a16.064 16.064 0 0 1 4.72 11.394c0 4.45-1.804 8.479-4.72 11.395a16.063 16.063 0 0 1-11.394 4.72c-4.45 0-8.478-1.804-11.394-4.72a16.065 16.065 0 0 1-4.72-11.395c0-4.45 1.803-8.478 4.72-11.394A16.063 16.063 0 0 1 21.5 5.263Z"
          stroke="#D3AD36"
          strokeWidth={0.771}
        />
        <Path
          d="M37.246 0c0 2.89 1.756 4.023 3.134 4.468l.261.077.126.033.241.055.114.023.212.036.274.036.309.024.083.002v32.492c-2.89 0-4.023 1.756-4.468 3.134l-.077.261a6.125 6.125 0 0 0-.033.126l-.055.241a6.301 6.301 0 0 0-.023.114l-.036.212-.036.274-.024.309-.002.083H4.754c0-2.89-1.756-4.023-3.134-4.468l-.261-.077a6.125 6.125 0 0 0-.126-.033l-.241-.055a6.3 6.3 0 0 0-.114-.023l-.212-.036-.274-.036-.309-.024L0 37.246V4.754c2.89 0 4.023-1.756 4.468-3.134l.077-.261.033-.126.055-.241a6.3 6.3 0 0 0 .023-.114l.036-.212.036-.274.024-.309L4.754 0h32.492Zm-.782.827H5.503l-.04.237a6.454 6.454 0 0 1-.648 1.846c-.756 1.398-2 2.332-3.756 2.595l-.232.03v30.961l.237.041a6.454 6.454 0 0 1 1.846.648c1.398.756 2.332 2 2.595 3.756l.03.232h30.96l.042-.237a6.454 6.454 0 0 1 .648-1.846c.756-1.398 2-2.332 3.756-2.595l.232-.031V5.504l-.237-.041a6.454 6.454 0 0 1-1.846-.648c-1.398-.756-2.332-2-2.595-3.756l-.031-.232Z"
          fill="#CCCBCB"
          fillRule="nonzero"
        />
      </G>
    </Svg>
  );
};
